import React from 'react';
import { DsCard, DsIcon, DsTooltip } from '@tokenyico/design-system/dist/reactJS';
import { useTranslation } from 'react-i18next';
import { currencyFormat } from '@tokenyico/design-system';

const PaymentInfo = ({ order, paymentInfo }) => {
  const { t } = useTranslation();

  return (
    <>
      <header>
        <h3>{t('shared.paymentInfo')}</h3>
      </header>

      <DsCard shadowDistance={0} padding={3} className="payment-information">
        <div>
          <p className="_text-coolGrey-400">{t('shared.amountToReceive')}</p>
          <div className="h6">
            {['CANCELED_BY_INVESTOR', 'CANCELED_BY_ISSUER'].includes(order.status) ? (
              '-'
            ) : order.totalRedemptionAmount ? (
              currencyFormat(order.totalRedemptionAmount, order.paymentCurrency, true)
            ) : (
              <DsTooltip theme="light" isVisibleOnHover text={t('shared.amountToPayNull')}>
                <DsIcon name="help" iconSize="14px" color="var(--warning)" />
              </DsTooltip>
            )}
          </div>
        </div>
        <div className="_grid _ptop-2">
          <div className="_col(6)">
            {paymentInfo.bankName && (
              <div className="payment-information--key">{t('shared.bankName')}</div>
            )}
            {paymentInfo.accountOwner && (
              <div className="payment-information--key">{t('shared.accountOwner')}</div>
            )}
            {paymentInfo.bicSwift && (
              <div className="payment-information--key">{t('shared.swiftbic')}</div>
            )}
            {paymentInfo.iban && <div className="payment-information--key">{t('shared.iban')}</div>}
            {Object.entries(paymentInfo).map((entry) => {
              const [key, value] = entry;
              const isHTML = /<\/?[a-z][\s\S]*>/i.test(value);
              if (['bankName', 'accountOwner', 'bicSwift', 'iban'].includes(key) || isHTML)
                return null;
              const str = key.replace(/([A-Z])/g, ' $1');
              return (
                <div key={key} className="payment-information--key">
                  {str.charAt(0).toUpperCase() + str.slice(1)}
                </div>
              );
            })}
          </div>

          <div className="_col(6)">
            <div className="payment-information--value">{paymentInfo.bankName}</div>
            <div className="payment-information--value">{paymentInfo.accountOwner}</div>
            <div className="payment-information--value">{paymentInfo.bicSwift}</div>
            <div className="payment-information--value">{paymentInfo.iban}</div>
            {Object.entries(paymentInfo).map((entry) => {
              const [key, value] = entry;
              const isHTML = /<\/?[a-z][\s\S]*>/i.test(value);
              if (['bankName', 'accountOwner', 'bicSwift', 'iban'].includes(key) || isHTML)
                return null;
              return (
                <div key={key} className="payment-information--value">
                  {value}
                </div>
              );
            })}
          </div>
        </div>
      </DsCard>
    </>
  );
};
export default PaymentInfo;
